import React from "react";

export const MyCanvasesIcon = ({ stroke = "#113357" }: { stroke?: string }) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.5 3L6.5 3.00007H8.75H14C14.3978 3.00007 14.7794 3.19322 15.0607 3.53704C15.342 3.88085 15.5 4.34716 15.5 4.83339V12.1667C15.5 12.6529 15.342 13.1192 15.0607 13.463C14.7794 13.8068 14.3978 14 14 14H3.5C3.10218 14 2.72064 13.8068 2.43934 13.463C2.15804 13.1192 2 12.6529 2 12.1667V4.83332C2 4.3471 2.15804 3.88078 2.43934 3.53697C2.72064 3.19315 3.10218 3 3.5 3Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4.81206 5.44446L4.81206 11.5556" stroke={stroke} strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
};
